<template>
  <b-container class="page-container" fluid>
    <StandardCheckout :routeName="routeName" :combos="combos" :discount="discount" :variant="variant"/>
  </b-container>
</template>
<style lang="scss">

#time-counter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

#time-counter-container div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container span {
  float: right;
}
#time-counter-container .value {
  height: 60px;
}
#time-counter-container .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}
</style>

<script>
// @ is an alias to /src
import StandardCheckout from "@/components/checkout/standard/StandardCheckout.vue";

export default {
  title: 'Dropsmart Subscription Checkout',
  name: "Checkout",
  components: {
    StandardCheckout
  },
  created() {
    let pageName = this.$route.name;
    console.log(this.$route);
    if (pageName === 'BrandCheckout') {
      this.combos = [9];
    } else if(pageName === 'Gift') {
      this.combos = [5];
      this.variant = 'B';
    } else if(pageName === 'PrivateOffer') {
      this.combos = [53];
    } else if(pageName === 'GiftCard') {
      this.combos = null;
      this.variant = null; 
    } else {
      this.combos = [2,5];
      this.discount = "14%";
    }
  },
  data() {
    return {
      combos: null,
      discount: null,
      variant: 'A',
      routeName: this.$route.name,
    };
  }

};
</script>
